import React, { useEffect, useState } from "react";
import "./styles.scss";
import "../AddForm1/form.scss";
import { Empty } from "antd";
import {
  FileOutlined,
  FileWordOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileJpgOutlined,
  CheckCircleFilled,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import Dowolland from "../Icons/Dowolland";
import { withTranslation } from "react-i18next";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import { useSearchParams } from "react-router-dom";
import { fileKind } from "../AddForm1/FormSection";

const kindIcon = {
  pdf: <FilePdfOutlined />,
  word: <FileWordOutlined />,
  ppt: <FilePptOutlined />,
  img: <FileJpgOutlined />,
  other: <FileOutlined />,
};

function DocumentShow({ t }) {
  const lan = useSelector((state) => state.langReducer);
  const modaldoc = useSelector((state) => state.modaldoc);
  const [searchParams] = useSearchParams();
  const [documents, setDocument] = useState();
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;

  useEffect(() => {
    axios
      .get(url.url + `/category?application_id=${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        setDocument(res.data.data);
      });
  }, [modaldoc, lan]);

  const done = documents?.filter((d) => d.files?.length).length || 0;
  const pct = documents?.length ? done / documents.length : 0;
  const c = 2 * Math.PI * 18;

  return (
    <section className="af-card doc-card">
      <div className="af-card__head">
        <div className="af-card__title">
          <span className="af-card__num">
            <FileWordOutlined />
          </span>
          <h5>{t("Document")}</h5>
        </div>
        {documents?.length ? (
          <div className="doc-ring">
            <svg width="44" height="44" viewBox="0 0 44 44">
              <circle cx="22" cy="22" r="18" className="doc-ring__bg" />
              <circle
                cx="22"
                cy="22"
                r="18"
                className={
                  pct === 1 ? "doc-ring__val doc-ring__val--full" : "doc-ring__val"
                }
                strokeDasharray={c}
                strokeDashoffset={c * (1 - pct)}
              />
            </svg>
            <div>
              <b>
                {done}/{documents.length}
              </b>
              <span>{t("sections_filled")}</span>
            </div>
          </div>
        ) : null}
      </div>

      {!documents ? (
        <Empty description={t("Loading...")} />
      ) : !documents.length ? (
        <Empty description={t("No data")} />
      ) : (
        <div className="doc-list">
          {documents.map((res, i) => {
            const short = String(res.name ?? "").length <= 4;
            const count = res.files?.length || 0;
            return (
              <div
                className={count ? "doc-cat doc-cat--done" : "doc-cat"}
                key={res.id ?? i}
              >
                <div className="doc-cat__head">
                  <span className="doc-cat__num">
                    {short ? res.name : i + 1}
                    {count ? <CheckCircleFilled className="doc-cat__tick" /> : null}
                  </span>
                  <div className="doc-cat__title">
                    {short ? res?.description : `${res.name}. ${res?.description}`}
                  </div>
                  <span className={count ? "doc-count doc-count--ok" : "doc-count"}>
                    {count ? null : <ExclamationCircleFilled />}
                    {count}
                  </span>
                </div>

                {count ? (
                  <div className="doc-files">
                    {res.files.map((item) => {
                      const kind = fileKind(item?.file);
                      return (
                        <div className="doc-file" key={item.id ?? item.file}>
                          <span className={`doc-file__icon doc-file__icon--${kind}`}>
                            {kindIcon[kind]}
                          </span>
                          <div className="doc-file__body">
                            <a
                              className="doc-file__name"
                              href={item.file}
                              target="blank"
                            >
                              {item.name}
                            </a>
                            <span className="doc-file__meta">
                              {kind === "other"
                                ? t("File")
                                : String(item.file ?? "")
                                    .split(".")
                                    .pop()
                                    .toUpperCase()}
                              {item.status == 2 ? (
                                <span className="doc-status doc-status--bad">
                                  {t("File_rejected")}
                                </span>
                              ) : item.status == 4 ? (
                                <span className="doc-status doc-status--ok">
                                  {t("File_approved")}
                                </span>
                              ) : null}
                            </span>
                          </div>
                          <div className="doc-file__actions">
                            <a href={item.file} download title={t("Download")}>
                              <Dowolland width={16} height={16} />
                            </a>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="ins-read__empty">
                    <ExclamationCircleFilled />
                    {t("No data")}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
export default withTranslation()(DocumentShow);
